import { render, staticRenderFns } from "./pendingIndex.vue?vue&type=template&id=3d4ea61d&scoped=true&"
import script from "./pendingIndex.vue?vue&type=script&lang=js&"
export * from "./pendingIndex.vue?vue&type=script&lang=js&"
import style0 from "./pendingIndex.vue?vue&type=style&index=0&id=3d4ea61d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4ea61d",
  null
  
)

export default component.exports